/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 4.20 PM
 */

import axios from 'axios';
import cookie from './cookie';

const apiv2 = axios.create({
    baseURL: process.env.REACT_APP_APIV2_ROOT,
    headers: {
        Accept: 'application/json',
    },
});

// Request interceptor
apiv2.interceptors.request.use(async (request) => {
    const token = cookie.get('tpanel');

    await axios.get(`${process.env.REACT_APP_BASE_ROOT}/airlock/csrf-cookie`);

    if (token) {
        request.headers.common.Authorization = `Bearer ${token}`;
    }

    return request;
});

apiv2.interceptors.response.use(
    (response) => response.data,
    ({ response }) => {
        const { status, data } = response;
        if (status === 401) {
            cookie.remove('t');
            cookie.remove('rt');
            window.location.assign('/login');
        }

        // if (status === 500) {
        // Alert.error(`${status} - ${data.message}`);
        // }

        return Promise.resolve({ errors: data });
    },
);

export default apiv2;
